import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "./c96_home_collection.scss"
import InnerHTML from 'dangerously-set-html-content';
class C96HomeCollection extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeCardIndex: 0
        };
    };
    
    componentRender(data) {

        const handleClick = (direction) => {

            if (direction) {
                if (this.state.activeCardIndex < data.cards.length - 1) {
                    this.setState(
                        {
                            activeCardIndex: this.state.activeCardIndex + 1
                        }
                    )
                }
            } else {
                if (this.state.activeCardIndex > 0) {
                    this.setState(
                        {
                            activeCardIndex: this.state.activeCardIndex - 1
                        }
                    )
                }
            }
        }

        const sliderSettings = {
            arrows: false,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendDots: dots => {
                if (dots.length <= 3) {
                    return (
                        <div
                            style={{
                                padding: "10px"
                            }}
                        >
                            <ul style={{ margin: "0px" }}>
                                <li className="mobile-left-arrow-wrapper" onClick={() => this.slider.slickGoTo(this.state.activeCardIndex - 1)}>
                                    <div className="mobile-left-arrow" />
                                </li>
                                {dots}
                                <li className="mobile-right-arrow-wrapper" onClick={() => this.slider.slickGoTo(this.state.activeCardIndex + 1)}>
                                    <div className="mobile-right-arrow" />
                                </li>
                            </ul>
                        </div>
                    )
                } else {
                    const leftArrows = this.state.activeCardIndex > 1
                    const rightArrows = dots.length - this.state.activeCardIndex > 2
                    const startSlice = this.state.activeCardIndex == 0 ? 0 : this.state.activeCardIndex == dots.length - 1 ? this.state.activeCardIndex - 2 : this.state.activeCardIndex - 1
                    const endSlice = this.state.activeCardIndex == 0 ? this.state.activeCardIndex + 3 : this.state.activeCardIndex + 2
                    return (
                        <div
                            style={{
                                padding: "10px"
                            }}
                        >
                            <ul style={{ margin: "0px" }}>
                                <li className="mobile-left-arrow-wrapper" onClick={() => this.slider.slickGoTo(this.state.activeCardIndex - 1)}>
                                    <div className="mobile-left-arrow" />
                                </li>
                                {
                                    leftArrows &&
                                    <>
                                        <li>
                                            {dots[0]}
                                        </li>
                                        <li>
                                            <div className="mobile-dots">
                                                ...
                                            </div>
                                        </li>
                                    </>
                                }
                                {dots.slice(startSlice, endSlice)}
                                {
                                    rightArrows &&
                                    <>
                                        <li>
                                            <div className="mobile-dots">
                                                ...
                                            </div>
                                        </li>
                                        <li>
                                            {dots[dots.length - 1]}
                                        </li>
                                    </>
                                }
                                <li className="mobile-right-arrow-wrapper" onClick={() => this.slider.slickGoTo(this.state.activeCardIndex + 1)}>
                                    <div className="mobile-right-arrow" />
                                </li>
                            </ul>
                        </div>
                    )
                }
            },
            customPaging: i => (
                <div className="mobile-dots">
                    {i + 1}
                </div>
            ),
            afterChange: () => this.setState(state => ({ activeCardIndex: state.activeCardIndex })),
            beforeChange: (current, next) => this.setState({ activeCardIndex: next }),
        };

        return (
            <div className="home-collection">
                <div className="home-collection-title ">
                    {data.title}
                    <hr />
                </div>
                <div className="subtitle">
                    {data.subtitle}
                </div>
                <div className="mobile collection-wrapper d-flex pb-4">
                    <Slider ref={slider => (this.slider = slider)}  {...sliderSettings}>
                        {
                            data.cards.map((card, index) => {
                                return (
                                    <>
                                        <div className="collection-image  ">
                                            <img src={card.image} alt="collection image" />
                                        </div>
                                        <div className="collection-content">
                                            <div className="collection-content-title">
                                                {card.title}
                                            </div>
                                            <div className="collection-content-main-content">
                                                <InnerHTML html={card.content} />
                                            </div>
                                            <div className="collection-content-button">
                                                <button>
                                                    <a href={card.link_url}>{card.link_title}</a>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </Slider>
                </div>
                <div className="collection-wrapper d-flex">
                    <div className="collection-content col-xs-12 col-md-6 ">
                        <div className="collection-content-title">
                            {data.cards[this.state.activeCardIndex].title}
                        </div>
                        <div key={this.state.activeCardIndex} className="collection-content-main-content">
                            <InnerHTML html={data.cards[this.state.activeCardIndex].content} />
                        </div>
                        <div className="collection-content-button">
                            <button>
                                <a href={data.cards[this.state.activeCardIndex].link_url}>{data.cards[this.state.activeCardIndex].link_title}</a>
                            </button>
                        </div>
                        <div className="arrow-handlers">
                            <button type="button" aria-label="left-arrow" onClick={() => handleClick(false)} className={`arrow-wrapper-left${this.state.activeCardIndex == 0 ? " disabled" : ""}`}>
                                <div className="arrow-left">

                                </div>
                            </button>
                            <button type="button" aria-label="right-arrow" onClick={() => handleClick(true)} className={`arrow-wrapper-right${this.state.activeCardIndex == data.cards.length - 1 ? " disabled" : ""}`}>
                                <div className="arrow-right">

                                </div>
                            </button>
                        </div>
                    </div>
                    <div className="collection-image col-xs-12 col-md-6 float-right ">
                        <img alt="collection image" src={data.cards[this.state.activeCardIndex].image} />
                    </div>
                </div>
            </div>)
    }
}

export default C96HomeCollection;